import {
  AdvancedFeasibilityFilters,
  FeasibilityAdvancedFilterType,
} from '../models';

export const ADVANCED_FILTER_TYPE: Record<
  'EXCLUDE' | 'INCLUDE',
  FeasibilityAdvancedFilterType
> = {
  EXCLUDE: 'exclude',
  INCLUDE: 'include',
};

export const EMPTY_ADVANCED_FEASIBILITY_FILTERS: AdvancedFeasibilityFilters = {
  type: ADVANCED_FILTER_TYPE.EXCLUDE,
  dateRange: { start: null, end: null },
  criteria: [],
  matchedGroupIds: [],
  manualGroupIds: [],
  respondentStatuses: [],
  excludeFromFeasibleAudience: false,
  psidRefs: [],
};

export const NO_PSIDS_FOUND_MESSAGE = 'There are no PSIDs for this selection.';
